var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { Typography } from '../../utils/Typography';
var Messages = {
    404: 'Page introuvable !',
    401: 'Accès interdit !',
    403: "Connecté mais l'accès à la zone demandée est interdit !",
    400: 'Une erreur est survenue !',
    422: 'Échec de la validation !',
    500: 'Erreur interne du serveur !',
};
export var isError = function (value) {
    return value.type === 'error';
};
export var Error = function (_a) {
    var _b = _a.status, status = _b === void 0 ? 500 : _b, _c = _a.message, message = _c === void 0 ? null : _c;
    return (_jsxs(Stack, __assign({ justifyContent: "center", alignItems: "center", padding: 5, spacing: 2 }, { children: [_jsxs(Typography, __assign({ color: "error", variant: "h1" }, { children: ["Erreur ", status] })), message ? (_jsx(Typography, __assign({ color: "error", variant: "h3" }, { children: message }))) : (Messages[status] && (_jsxs(Typography, __assign({ color: "error", variant: "h3" }, { children: ["Oups ! ", Messages[status]] }))))] })));
};
//# sourceMappingURL=Error.js.map